import { CommonModule, formatDate } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ACLCanType, ACLService, DelonACLModule } from '@delon/acl';
import { _HttpClient } from '@delon/theme';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { Subscription } from 'rxjs';
import { QueryParamsService } from 'src/app/core/util/query-params.service';
import { ReportingService } from 'src/app/core/util/reporting.service';

import { ReportCloneComponent } from '../report-clone/report-clone.component';
import { ReportTasksComponent } from '../report-tasks/report-tasks.component';

@Component({
  selector: 'app-report-header',
  templateUrl: './report-header.component.html',
  styleUrls: ['./report-header.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    NzButtonModule,
    NzMenuModule,
    NzIconModule,
    NzSpaceModule,
    NzDropDownModule,
    DelonACLModule,
    ReportCloneComponent,
    ReportTasksComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportHeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  private _designAcl: ACLCanType = '';
  private params$: Subscription;
  @Input() useQueue: boolean = false;
  @Input() reportType!: string;

  @Input() set designAcl(value: ACLCanType) {
    this._designAcl = value;
  }

  @Input() reportUrl: string = '';
  @Input() filter: any = null;
  @Input() includeBatch: boolean = false;

  @Input() validate: (() => Promise<boolean>) | undefined;
  @Input() reportInquiry: (() => Promise<any>) | undefined;
  @Input() prefixActions: TemplateRef<any> | null = null;
  //@Input() exportTXT: boolean = false;

  @Output() readonly batchEmailClicked = new EventEmitter();

  @Output() readonly isCloneABIRCasRegistered = new EventEmitter();

  @ViewChild('clone') clone!: ReportCloneComponent;
  @ViewChild('tasks') tasks!: ReportTasksComponent;
  loading: any = {
    preview: false,
    design: false,
    inquiry: false,
    batch: false
  };
  report: any = {};
  reports: any[] = [];

  get designAcl() {
    if (this._designAcl) return this._designAcl;
    else return `${this.selectedReportType}.design`;
  }

  get selectedReportType() {
    if (!this.report) return this.reportType;
    return this.report.reportType;
  }

  constructor(
    private reporting: ReportingService,
    private http: _HttpClient,
    public msg: NzMessageService,
    private route: ActivatedRoute,
    private queryParams: QueryParamsService,
    private cdr: ChangeDetectorRef,
    private modalSrv: NzModalService,
    public acl: ACLService
  ) {
    this.params$ = this.route.queryParams.subscribe(() => {
      this.queryParams.readParams(this.filter);
    });
  }

  // private readParams() {
  //   if (this.filter) {
  //     const paramValues = { ...this.route.snapshot.queryParams };
  //     if (Object.keys(paramValues).length > 0)
  //       Object.assign(this.filter, paramValues);
  //   }
  // }

  ngAfterViewInit() {
    setTimeout(() => this.queryParams.readParams(this.filter), 100);
  }

  ngOnDestroy(): void {
    this.params$?.unsubscribe();
  }

  ngOnInit(): void {
    this.http
      .get(`${this.reporting.reportServerMirrorUrl}/api/ReportFiles/GetByType`, {
        reportType: this.reportType
      })
      .subscribe((res: any[]) => {
        this.reports = [...res];
        if (this.reports.length > 0) {
          let defaultReport = this.reports.find(_ => _.isDefault);
          if (!defaultReport) {
            defaultReport = this.reports[0];
          }
          this.selectReport(defaultReport);
        }
      });
  }

  selectReport(report: any) {
    if (report) {
      this.report = report;
      this.reportUrl = report.reportUrl;

      if(report.isPredefined === false) {
        const data = ['clone', report.isBIRFormat]
        this.isCloneABIRCasRegistered.emit(data);
      } else {
        const data = ['predefined', true]
        this.isCloneABIRCasRegistered.emit(data);
      }

      this.cdr.detectChanges();
    }
  }
  async design() {
    if (!this.reportUrl) return;

    let valid = true;

    if (this.validate) {
      // var valid = this.validate();
      // if (!valid) return;
      await this.validate()
        .then(res => {
          if (res === false) {
            valid = false;
            return;
          }
        })
        .catch(() => {
          valid = false;
          return;
        });
    }

    if (!valid) return;

    if (this.report.isPredefined) {
      var development = document.location.hostname.indexOf('localhost') !== -1;
      if (!development) {
        this.showClone();
        return;
      }
    }
    this.loading.design = true;

    const formattedFilter = this.getFilterData(this.filter);
    this.reporting
      .design(this.reportType, this.reportUrl, formattedFilter)
      .then(() => {
        this.loading.design = false;
        this.cdr.detectChanges();
      })
      .catch(() => {
        this.loading.design = false;
        this.cdr.detectChanges();
      });
  }

  showClone() {
    this.clone.show(this.report, true);
  }

  showTasks() {
    this.tasks.show();
  }

  async preview() {
    if (!this.reportUrl) return;

    let valid = true;

    if (this.validate) {
      // var valid = this.validate();
      // if (!valid) return;
      await this.validate()
        .then(res => {
          if (res === false) {
            valid = false;
            return;
          }
        })
        .catch(() => {
          valid = false;
          return;
        });
    }

    if (!valid) return;

    this.loading.preview = true;

    const formattedFilter = this.getFilterData(this.filter);
    this.reporting
      .preview('', this.reportType, this.reportUrl, formattedFilter)
      .then(() => {
        this.loading.preview = false;
        this.cdr.detectChanges();
      })
      .catch(() => {
        this.loading.preview = false;
        this.cdr.detectChanges();
      });
  }

  private getFilterData(filter: any) {
    // Format all dates to yyyy-MM-dd
    const formattedFilter = { ...filter };
    Object.keys(formattedFilter).forEach(key => {
      if (key === "showLevel")
        formattedFilter[key] = parseInt(formattedFilter[key]);
      if (formattedFilter[key] instanceof Date) {
        formattedFilter[key] = formatDate(
          formattedFilter[key],
          'yyyy-MM-dd',
          'en'
        );
      }
    });
    return formattedFilter;
  }

  async queue() {
    if (!this.reportUrl) return;

    let valid = true;

    if (this.validate) {
      // var valid = this.validate();
      // if (!valid) return;
      await this.validate()
        .then(res => {
          if (res === false) {
            valid = false;
            return;
          }
        })
        .catch(() => {
          valid = false;
          return;
        });
    }

    if (!valid) return;

    this.loading.queue = true;

    const formattedFilter = this.getFilterData(this.filter);
    this.reporting
      .queue(this.reportType, this.reportUrl, formattedFilter)
      .then(() => {
        this.showTasks();
        this.loading.queue = false;
        this.cdr.detectChanges();
      })
      .catch(() => {
        this.loading.queue = false;
        this.cdr.detectChanges();
      });
  }

  async inquiry() {
    if (!this.reportInquiry) return;

    let valid = true;

    if (this.validate) {
      await this.validate()
        .then(res => {
          if (res === false) {
            valid = false;
            return;
          }
        })
        .catch(() => {
          valid = false;
          return;
        });
    }
    if (!valid) return;

    this.loading.inquiry = true;

    this.reportInquiry()
      .then(() => {
        this.loading.inquiry = false;
        this.cdr.detectChanges();
      })
      .catch(() => {
        () => {
          this.loading.inquiry = false;
          this.cdr.detectChanges();
        };
      })
      .finally(() => {
        this.loading.inquiry = false;
        this.cdr.detectChanges();
      });
  }
}
